import { hideLoader } from "action/loader/hideLoader";
import { setProductDeliveryDetails } from "action/utils/setProductDeliveryDetails";
import { IProductDeliveryDetails } from "api/interfaces/product-api.type";
import { RootState } from "interfaces/generics.type";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { getProductDeliveryDetailsSkuApi } from "../../../api/product/getProductDeliveryDetailsSkuApi";
import NewDeliveryMethodSelector from "../new-delivery-method-selector/NewDeliveryMethodSelector";

function ProductDeliveryMethodSelector(props: any) {
  const { product, fromSideMenu, compactOnMobile } = props;
  const { sku } = product;
  const router = useRouter();
  const dispatch = useDispatch();

  const [productDeliveryMethodDetails, setProductDeliveryMethodDetails] = useState<IProductDeliveryDetails>();
  const [isLoading, setIsLoading] = useState(true);
  const { postalCode, hasRefreshed } = useSelector((store: RootState) => store.shoppingCart);
  const { availableDeliveryMethods } = useSelector((store: RootState) => store.utils);

  const getDeliveryDetails = () => {
    getProductDeliveryDetailsSkuApi(sku, postalCode, 1)
      .then(({ data }) => {
        setIsLoading(false);
        if (!data.success) {
          router.replace("/page-not-found");
        } else {
          const { productDeliveryDetails } = data;
          dispatch(setProductDeliveryDetails(productDeliveryDetails.availableDeliveryMethodsDetails));
          setProductDeliveryMethodDetails(productDeliveryDetails);
          // TODO cal min time for calling api again.
        }
      })
      .catch(() => {
        setIsLoading(false);
        dispatch(hideLoader());
      });
  };

  useEffect(() => {
    if (hasRefreshed) {
      getDeliveryDetails();
    }
  }, [postalCode, sku, hasRefreshed]);

  if (isLoading || !productDeliveryMethodDetails) {
    return (
      <>
        <Skeleton height={60} count={2} />
        <Skeleton height={40} count={1} />
      </>
    );
  }

  return (
    <NewDeliveryMethodSelector
      availableDeliveryMethodsDetails={availableDeliveryMethods}
      postalCode={postalCode}
      fromSideMenu={fromSideMenu}
      inputName="product-delivery-method"
      product={product}
      compactOnMobile={compactOnMobile}
    />
  );

  // return (
  //   <DeliveryMethodSelector
  //     availableDeliveryMethodsDetails={availableDeliveryMethodsDetails}
  //     postalCode={postalCode}
  //     fromSideMenu={fromSideMenu}
  //     inputName="product-delivery-method"
  //   />
  // );
}

export default ProductDeliveryMethodSelector;
